import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import TbodyVivier from './components/tbody.vivier';
import ScrollableTableWrapper from '../../../../../../components/table/components/ScrollableTableWrapper';

const TableVivier = ({ users, setSortName, setAddVivier, sortName, list }) => {
  const [selectAll, setSelectAll] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const id = new URLSearchParams(location.search).get('idTempWorker');
    if (id) setSelectedId(id);
  }, [location]);

  useEffect(() => {
    if (users?.length && list?.length > 0) {
      setSelectAll(users.every((user) => list.includes(user._id)));
    } else {
      setSelectAll(false);
    }
  }, [users, list]);

  const toggleSelectAll = () => {
    setSelectAll(!selectAll);
    setAddVivier(!selectAll ? users.map((user) => user._id) : []);
  };

  return (
    <ScrollableTableWrapper>
      <table className="table-auto w-full text-gray-500 ft-sm">
        <thead className="sticky top-0 z-10">
          <tr className="sticky top-0 z-10 border-b border-gray-100">
            <th scope="col" className="sticky top-0 z-10 py-3.5 pl-4 md:pl-8 pr-2 font-medium text-left text-sm text-gray-700 bg-gray-50 border-b border-gray-100 min-w-[280px]">
              <div className="flex items-center gap-x-3">
                <input type="checkbox" checked={selectAll} onChange={toggleSelectAll} />
                <span>CANDIDAT</span>
              </div>
            </th>
            <th scope="col" className="sticky top-0 z-10 py-3.5 px-2 text-left text-sm font-medium text-gray-700 bg-gray-50 border-b border-gray-100 min-w-[200px]">
              CONTACT
            </th>
            <th scope="col" className="sticky top-0 z-10 py-3.5 px-2 text-left text-sm font-medium text-gray-700 bg-gray-50 border-b border-gray-100 min-w-[120px] max-w-[180px]">
              VIVIER
            </th>
            <th scope="col" className="sticky top-0 z-10 py-3.5 pl-2 pr-4 md:pr-8 text-left text-sm font-medium text-gray-700 bg-gray-50 border-b border-gray-100 w-fit" />
          </tr>
        </thead>
        <tbody>
          {users?.map((user) => (
            <TbodyVivier
              key={user._id}
              champsBody={user}
              users={users}
              setAddVivier={setAddVivier}
              list={list}
              selectedId={selectedId}
              setSelectedId={setSelectedId}
            />
          ))}
        </tbody>
      </table>
    </ScrollableTableWrapper>
  );
};

export default TableVivier;
